namespace GeniuzPOS.InitialData {
    export class PsQRPromptPayColumns {
        static columnsKey = 'InitialData.PsQRPromptPay';
    }
}
